// Operator-type buckets — the upstream `oprTypeFilter` is a comma-
// separated list of opaque codes (TCOV / OVOV / SPOT / OVTO / TCTO);
// we expose the user-facing groupings the original WW application used.
// Mutually exclusive: picking one bucket drives one refetch of the
// schedule with that bucket's code list. Default is "all" so a fresh
// landing surfaces every voyage WW has any commercial interest in.

export type OprBucketId = "all" | "direct" | "spot" | "tcout" | "direct-sc";

export interface OprBucket {
  id: OprBucketId;
  label: string;
  // Joined as the `oprTypeFilter` query param. Order matches the
  // original application's listing so the cache key (URL incl. order)
  // stays stable across sessions.
  codes: string[];
}

export const OPR_BUCKETS: readonly OprBucket[] = [
  { id: "all",       label: "All",            codes: ["TCOV", "OVOV", "SPOT", "OVTO", "TCTO"] },
  { id: "direct",    label: "Direct",         codes: ["TCOV", "OVOV"] },
  { id: "spot",      label: "Space Charter",  codes: ["SPOT"] },
  { id: "tcout",     label: "TC OUT",         codes: ["OVTO", "TCTO"] },
  { id: "direct-sc", label: "Direct + S/C",   codes: ["TCOV", "OVOV", "SPOT"] },
] as const;

export const DEFAULT_OPR_BUCKET: OprBucketId = "all";

export function oprFilterFor(id: OprBucketId): string {
  const bucket = OPR_BUCKETS.find((b) => b.id === id) ?? OPR_BUCKETS[0]!;
  return bucket.codes.join(",");
}

export function isOprBucketId(value: string): value is OprBucketId {
  return OPR_BUCKETS.some((b) => b.id === value);
}
